import './AngleDivider.css';

const AngleDivider = ({ variant = "slant", color = "#ffffff" }) => {
  let path;

  switch (variant) {
    case "wave":
      path = "M0,0 C360,100 1080,0 1440,100 L1440,0 L0,0 Z";
      break;
    case "peak":
      path = "M0,100 L720,0 L1440,100 L1440,0 L0,0 Z";
      break;
    default: // "slant"
      path = "M0,0 L1440,100 L0,100 Z";
      break;
  }

  return (
    <div className="angle-divider">
      <svg
        viewBox="0 0 1440 100"
        preserveAspectRatio="none"
        className="angle-divider-svg"
      >
        <path d={path} fill={color} />
      </svg>
    </div>
  );
};

export default AngleDivider;
